import { SVGProps } from 'react';

const DirectionArrow = ({
  width = 18,
  height = 15,
  fill = '#00AEC7',
  ...otherProps
}: SVGProps<SVGSVGElement>) => (
  <svg
    height={height + 'px'}
    width={width + 'px'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 15"
    {...otherProps}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3997 6.24932L17.6497 7.49931L10.1498 14.9992L8.89981 13.7493L14.2511 8.39793H0V6.63018L14.2788 6.63018L8.8986 1.24999L10.1486 0L16.3988 6.25024L16.3997 6.24932Z"
      fill={fill}
    />
  </svg>
);

export default DirectionArrow;
